import { decimalToTime, timeToDecimal } from "./timeConversion";

/**
 * Genera las opciones de hora de INICIO ("Desde") en intervalos de 15 min.
 * @param lastAvailableTime Piso dinamico (fin del bloque anterior o 0).
 * @param openTime Hora de apertura del local en formato decimal 24h (default 0 = medianoche).
 * @param closeTime Hora de cierre del local en formato decimal 24h (default 24 = sin tope).
 * @param keepValue Valor ya guardado ("HH:MM AM/PM"); se preserva como opcion aunque
 *   exceda el horario del local, siempre que sea coherente con el piso dinamico.
 *   Asi no se borra un horario existente del empleado que estaba fuera del rango del local.
 *
 * El inicio efectivo es el mayor entre el piso dinamico y la apertura del local.
 * Se genera hasta antes del cierre (closeTime excluyente) para dejar espacio a un "Hasta".
 */
export const getSchedulesList = (
  lastAvailableTime: number,
  openTime: number = 0,
  closeTime: number = 24,
  keepValue: string = ""
) => {
  const startTime = Math.max(lastAvailableTime, openTime);
  const decimals: number[] = [];
  for (let index = startTime; index < closeTime && index < 24; index += 0.25) {
    decimals.push(Number(index.toFixed(2)));
  }
  // Preservar el valor guardado aunque caiga fuera del horario del local.
  const keep = timeToDecimal(keepValue);
  if (keep !== null && keep >= lastAvailableTime && keep < 24 && !decimals.includes(keep)) {
    decimals.push(keep);
    decimals.sort((a, b) => a - b);
  }
  return decimals.map(decimalToTime);
};
